import React from "react";
import SwitchButton from "../../common/SwitchButton";
import { BsDot } from "react-icons/bs";
import { useFilterMap } from "../../../context/FilterMapContext";
interface PropType {
  open: boolean;
  onClose: () => void;
}
function LayerInfoOption({ open, onClose }: PropType) {
  const { filterMap, onSelectFilter } = useFilterMap();
  const handleSetStatus = (keyword: string, status: boolean) => {
    onSelectFilter(keyword, status);
  };

  return (
    <div className="relative">
      {open && (
        <div className="absolute -right-14 md:right-4 -top-[14rem] bg-primary-contrast z-10 w-[360px] h-auto p-6 flex flex-col gap-2 shadow-z8 rounded-3xl">
          <div className="flex justify-between pb-2 border-b-[1px] border-gray-1">
            <p className="text-sm text-text-primary font-normal">ชั้นข้อมูล</p>
            <button onClick={onClose}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.2516 4.75819C14.9266 4.43319 14.4016 4.43319 14.0766 4.75819L10.0016 8.82485L5.92656 4.74985C5.60156 4.42485 5.07656 4.42485 4.75156 4.74985C4.42656 5.07485 4.42656 5.59985 4.75156 5.92485L8.82656 9.99985L4.75156 14.0749C4.42656 14.3999 4.42656 14.9249 4.75156 15.2499C5.07656 15.5749 5.60156 15.5749 5.92656 15.2499L10.0016 11.1749L14.0766 15.2499C14.4016 15.5749 14.9266 15.5749 15.2516 15.2499C15.5766 14.9249 15.5766 14.3999 15.2516 14.0749L11.1766 9.99985L15.2516 5.92485C15.5682 5.60819 15.5682 5.07485 15.2516 4.75819Z"
                  fill="#8E8E8E"
                />
              </svg>
            </button>
          </div>
          <p className="text-sm text-text-primary font-normal">
            ชนิดของดาวเทียม
          </p>
          <div className="flex justify-between">
            <p className="text-sm text-text-primary font-light">
              จุดความร้อนระบบ VIIRS
            </p>
            <SwitchButton
              enabled={filterMap?.openVIIRS}
              onChange={() =>
                handleSetStatus("openVIIRS", !filterMap?.openVIIRS)
              }
            />
          </div>
          <div className="flex justify-between">
            <div className="flex gap-1 items-center">
              <BsDot size={16} />
              <p className="text-sm text-text-primary font-light">
                ดาวเทียม Suomi NPP
              </p>
            </div>
            <SwitchButton
              enabled={filterMap?.openNPP}
              onChange={() => handleSetStatus("openNPP", !filterMap?.openNPP)}
            />
          </div>
          <div className="flex justify-between">
            <div className="flex gap-1 items-center">
              <BsDot size={16} />
              <p className="text-sm text-text-primary font-light">
                ดาวเทียม NOAA-20
              </p>
            </div>

            <SwitchButton
              enabled={filterMap.openNORR}
              onChange={() => handleSetStatus("openNORR", !filterMap?.openNORR)}
            />
          </div>
          <div className="flex justify-between pb-2 border-b-[1px] border-gray-1">
            <p className="text-sm text-text-primary font-light">
              จุดความร้อนระบบ MODIS
            </p>
            <SwitchButton
              enabled={filterMap.openModis}
              onChange={() =>
                handleSetStatus("openModis", !filterMap?.openModis)
              }
            />
          </div>
          <p className="text-sm text-text-primary font-normal">
            เขตพื้นที่รับผิดชอบ
          </p>
          <div className="flex justify-between">
            <div className="flex gap-1 items-center">
              <div className="w-4 h-4 rounded-full bg-custom-4" />
              <p className="text-sm text-text-primary font-light">
                ป่าอนุรักษ์
              </p>
            </div>
            <SwitchButton
              enabled={filterMap?.openProtectedForest}
              onChange={() =>
                handleSetStatus(
                  "openProtectedForest",
                  !filterMap?.openProtectedForest
                )
              }
            />
          </div>
          <div className="flex justify-between">
            <div className="flex gap-1 items-center">
              <div className="w-4 h-4 rounded-full bg-custom-2" />
              <p className="text-sm text-text-primary font-light">เขต สปก.</p>
            </div>
            <SwitchButton
              enabled={filterMap?.openALRO}
              onChange={() => handleSetStatus("openALRO", !filterMap?.openALRO)}
            />
          </div>
          <div className="flex justify-between">
            <div className="flex gap-1 items-center">
              <div className="w-4 h-4 rounded-full bg-custom-5" />
              <p className="text-sm text-text-primary font-light">
                ป่าสงวนแห่งชาติ
              </p>
            </div>
            <SwitchButton
              enabled={filterMap?.openConservedForest}
              onChange={() =>
                handleSetStatus(
                  "openConservedForest",
                  !filterMap?.openConservedForest
                )
              }
            />
          </div>
          <div className="flex justify-between">
            <div className="flex gap-1 items-center">
              <div className="w-4 h-4 rounded-full bg-custom-6" />
              <p className="text-sm text-text-primary font-light">
                ริมทางหลวง(50 เมตร)
              </p>
            </div>
            <SwitchButton
              enabled={filterMap?.openHighway}
              onChange={() =>
                handleSetStatus("openHighway", !filterMap?.openHighway)
              }
            />
          </div>
          <div className="flex justify-between">
            <div className="flex gap-1 items-center">
              <div className="w-4 h-4 rounded-full bg-custom-1" />
              <p className="text-sm text-text-primary font-light">
                พื้นที่เกษตร
              </p>
            </div>
            <SwitchButton
              enabled={filterMap?.openAgriculture}
              onChange={() =>
                handleSetStatus("openAgriculture", !filterMap?.openAgriculture)
              }
            />
          </div>

          <div className="flex justify-between pb-2 border-b-[1px] border-gray-1">
            <div className="flex gap-1 items-center">
              <div className="w-4 h-4 rounded-full bg-custom-3" />
              <p className="text-sm text-text-primary font-light">
                ชุมชนและอื่น ๆ
              </p>
            </div>
            <SwitchButton
              enabled={filterMap?.openVillage}
              onChange={() =>
                handleSetStatus("openVillage", !filterMap?.openVillage)
              }
            />
          </div>

          <p className="text-sm text-text-primary font-normal">
            จุดความร้อนนอกประเทศ
          </p>
          <div className="flex justify-between pb-2 border-b-[1px] border-gray-1">
            <div className="flex gap-1 items-center">
              <div className="w-4 h-4 rounded-full bg-custom-7" />
              <p className="text-sm text-text-primary font-light">
                จุดความร้อนนอกประเทศ
              </p>
            </div>
            <SwitchButton
              enabled={filterMap?.openOtherCountry}
              onChange={() =>
                handleSetStatus(
                  "openOtherCountry",
                  !filterMap?.openOtherCountry
                )
              }
            />
          </div>

          {/* <p className="text-sm text-text-primary font-normal">ขอบเขตพื้นที่</p>
          <div className="flex justify-between ">
            <p className="text-sm text-text-primary font-light">
              เส้นแบ่งขอบเขตระดับจังหวัด
            </p>
            <SwitchButton
              enabled={filterMap?.openProvice}
              onChange={() =>
                handleSetStatus("openProvice", !filterMap?.openProvice)
              }
            />
          </div>
          <div className="flex justify-between">
            <p className="text-sm text-text-primary font-light">
              เส้นแบ่งขอบเขตระดับอำเภอ
            </p>
            <SwitchButton
              enabled={filterMap?.openDistrict}
              onChange={() =>
                handleSetStatus("openDistrict", !filterMap?.openDistrict)
              }
            />
          </div>
          <div className="flex justify-between">
            <p className="text-sm text-text-primary font-light">
              เส้นแบ่งขอบเขตระดับตำบล
            </p>
            <SwitchButton
              enabled={filterMap?.openSubDistrict}
              onChange={() =>
                handleSetStatus("openSubDistrict", !filterMap?.openSubDistrict)
              }
            />
          </div> */}
        </div>
      )}
    </div>
  );
}

export default LayerInfoOption;
